import angular from 'angular';
import loansSignUpFormSimulationHousingChangeWarningComponent from './loansSignUpFormSimulationHousingChangeWarning.component';

let loansSignUpFormSimulationHousingChangeWarningModule = angular.module('loansSignUpFormSimulationHousingChangeWarning', [])

.component('loansSignUpFormSimulationHousingChangeWarning', loansSignUpFormSimulationHousingChangeWarningComponent)

.name;

export default loansSignUpFormSimulationHousingChangeWarningModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpFormSimulation/loansSignUpFormSimulationHousingChangeWarning/loansSignUpFormSimulationHousingChangeWarning.js